"use strict";

import { Menu } from "./menu.js";
import { Psp } from "./psp.js";
import { Tooltip } from "../libraries/tooltip.js";

const header = document.querySelector("header");

let headerHeight = 0;
let lastScrollTop = 0;
let scrolled = false;
let timer;


class Settings {
    constructor() {
        this.windowOffsetY = window.pageYOffset || window.document.documentElement.scrollTop;

        this.breakpoints = {
            small: 920,
            medium: 1024,
            large: 1366
        };

        this.mainMenu = new Menu(
            document.querySelector(".menu-control"),
            document.querySelector("nav"),
            "menu-open",
            "menu-control-open",
            500
        );

        this.references = new Menu(
            document.querySelector(".references-link"),
            document.querySelector(".references-list"),
            "references-open",
            "references-control-open",
            300
        );
    }
}

function getQueryString(field) {
    var reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
    var string = reg.exec(window.location.href);
    return string ? string[1] : null;
};

function revealMenu() {
    let pos = window.pageYOffset;

    if (pos < headerHeight) {
        header.classList.remove("header-up");

        if (pos === 0) {
            header.classList.remove("header-down");
        }
    } else {
        if (pos > lastScrollTop) {
            header.classList.remove("header-down");
            header.classList.add("header-up");
        } else {
            header.classList.remove("header-up");
            header.classList.add("header-down");
        }
    }

    lastScrollTop = pos;
};

document.addEventListener("DOMContentLoaded", () => {

    var pageID = $('body').attr('id');
    if (pageID === 'home' || pageID === 'aboutpnh' || pageID === 'managingpnh' || pageID === 'community' || pageID === 'restools') {
        AOS.init({ once: true });
    }

    const settings = new Settings();

    let hb = header.getBoundingClientRect();

    headerHeight = hb.height;

    /* Set up menus */
    if (settings.mainMenu.toggler) {
        settings.mainMenu.toggler.addEventListener("click", (e) => {
            settings.mainMenu.toggle();
            $('html').toggleClass('menu-fixed');
            e.preventDefault();
        });
    }

    if (settings.references.toggler) {
        settings.references.toggler.addEventListener("click", (e) => {
            settings.references.toggle();
            e.preventDefault();
        });
    }

    /* Slide the header back in when the user scrolls up */
    setInterval(function () {
        if (scrolled) {
            revealMenu();
            scrolled = false;
        }
    }, 200);

    window.addEventListener("scroll", (e) => {
        scrolled = true;
    });

    window.addEventListener("resize", (e) => {
        if (settings.mainMenu.toggler) {
            if (settings.mainMenu.open) {
                settings.mainMenu.toggle();
                $('html').removeClass('menu-fixed');
            }

            let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

            if (w > settings.breakpoints["small"]) {
                $(settings.mainMenu.container).show();
            } else {
                $(settings.mainMenu.container).hide();
            }
        }


        // open all the <dd>s as any one of them
        // may have been closed on desktop
        var winw = $(window).width();
        if ($('.collapsible-link')[0] !== null && winw <= 768) {
            // check w changed and it's not iOS triggering a resize
            if (winw !== $(window).width()) { 
                if ($('dd').is(":hidden")) {
                    $('dd').css('display', 'block');
                    $('dt').addClass('open-shade');
                    winw = $(window).width();
                }
            }
        }
    });
    //Patient experiences switcher
    var curr = '';
    function changeVis(curr) {
        $('a.patname').attr('id', '');
        $('a.patname[data-name="' + curr + '"]').attr('id', 'active');
        $('.patientvideos[data-patient]').fadeOut(200);
        setTimeout(function () {
                //cssgrid yes
            $('.cssgrid .patientvideos[data-patient="' + curr + '"], .cssgridlegacy .patientvideos[data-patient="' + curr + '"]').css({'display': 'flex' }).fadeIn(200); 
                //cssgrid no
                //$('.no-cssgrid .patientvideos[data-patient="' + curr + '"]').css({ 'display': 'flex' }).fadeIn(200);
        },210);
    }
    $('a.patname[data-name]').on('click', function () {
        curr = $(this).attr('data-name');
        changeVis(curr);
    });

    // Wistia video modal
    $('a.showvideo').on('click', function () {
        $('#video').css('display', 'block');

        if ($(this).attr('data-video') !== null ) {
            var content = $(this).attr('data-video');
            $('#video .popup-content p').html('<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><iframe src="https://fast.wistia.net/embed/iframe/' + content + '?videoFoam=true" title="Wistia video player" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="100%" height="100%"></iframe></div></div>');
        }
        else {
            var contents = $(this).html();
            $('#video .popup-content p').html(contents);
        }
    });
    $('a.close-button, .popup-overlay').on('click', function () {
        $('#video').css('display', 'none');
        $('#user-interstitial').css('display', 'none');
        interstitial = 0;
        event.preventDefault();
    }); 

    // leaving site interstitial 
    var interstitial = 0;
    $('.external').on('click', function (event) {
        $('#user-interstitial').css('display', 'block');
        var href = $(this).attr('href');
        $('#modal-go').attr('href', href);
        interstitial = 1;
        event.preventDefault();
    });
    $('#modal-go').on('click', function () {
        $('#user-interstitial').css('display', 'none');
        interstitial = 0;
    });

    $('#modal-cancel').on('click', function (event) {
        $('#user-interstitial').css('display', 'none');
        interstitial = 0;
        event.preventDefault();
    });

    // glossary revealer
    let openAll = document.getElementsByClassName('open-all');
    $('.open-all').on('click', function () {
        $('.collapsible-block dt').addClass('open-shade');
        $('.collapsible-block dd').css('display', 'block');
    });

    let closeAll = document.getElementsByClassName('close-all');
    $('.close-all').on('click', function () {
        $('.collapsible-block dt').removeClass('open-shade');
        $('.collapsible-block dd').css('display', 'none');
    });
    
    let shadeToggles = document.getElementsByClassName("collapsible-link");
        
    for (let i = 0; i < shadeToggles.length; i++) {
        shadeToggles[i].addEventListener("click", (e) => {
            let shadeToggle = e.currentTarget;
            let shade = shadeToggle.nextElementSibling;

            if (shadeToggle.classList.contains("open-shade")) {
                $(shade).slideUp(100, function () {
                    shadeToggle.classList.remove("open-shade");
                });
            } else {
                $(shade).slideDown(100, function () {
                    shadeToggle.classList.add("open-shade");
                });
            }
            e.preventDefault();
        });
    }

    // ambassador form validation
    var fields = false,
        radioBttns = false,
        phoneViz = false;

    function checkfields() {
        $('.text-field').each(function () {
            var el = $(this);
            var myId = $(this).attr('id');
            if (el.val().length <= 0) {
                $('#' + myId + '-error').css({ 'display': 'inline', 'visibility': 'visible' });
                $('#' + myId + '-indicator').css({ 'display': 'block', 'visibility': 'visible' });
                $('#' + myId).css('border', '1px solid #d22c49');
            } else {
                $('#' + myId + '-error').css({ 'display': 'none', 'visibility': 'hidden' });
                $('#' + myId + '-indicator').css({ 'display': 'none', 'visibility': 'hidden' });
                $('#' + myId).css('border', '1px solid #f1f0f0');
                fields = true;
            }
        });
        if ($('label[for="phone"]').hasClass('hide') === false) {
            if ($('#phone').val().length <= 0) {
                $('#phone-error').css({ 'display': 'inline', 'visibility': 'visible' });
                $('#phone-indicator').css({ 'display': 'block', 'visibility': 'visible' });
                $('#phone').css('border', '1px solid #d22c49');
            }
            else {
                $('#phone-error').css({ 'display': 'none', 'visibility': 'hidden' });
                $('#phone-indicator').css({ 'display': 'none', 'visibility': 'hidden' });
                $('#phone').css('border', '1px solid #f1f0f0');
                phoneViz = true;
            }
        }
        else {
            phoneViz = true;
        }
    }
    function checkradios() {
        var patient = $('input#iam-patient').is(':checked'),
            careg = $('input#iam-caregiver').is(':checked'),
            age = $('input#ageverify').is(':checked');

        if (!patient && !careg) {
            $('#iam-indicator').css({ 'display': 'block', 'visibility': 'visible' });
            $('#iam-error').removeClass('hide');
        }
        if (!age) {
            $('#ageverify-indicator').css({ 'display': 'block', 'visibility': 'visible' });
            $('#ageverify-error').removeClass('hide');

        }
        else {
            $('#iam-indicator').css({ 'display': 'none', 'visibility': 'hidden' });
            $('#ageverify-indicator').css({ 'display': 'none', 'visibility': 'hidden' });
            $('#ageverify-error').addClass('hide');
            $('#iam-error').addClass('hide');
            radioBttns = true;
        }
    }
    $('input#ambassador').on('click', function (e) {
        checkfields();
        checkradios();
        if (fields === true && phoneViz === true && radioBttns === true) {
            return true;
        }
        e.preventDefault();
    });

    // signs & symptoms interactive states
    $('.body-part').on('mouseenter', function () {
        var partName = $(this).attr('id');
        $('li[name="' + partName + '"]').addClass('active');
        $(this).addClass('active');
    }).on('mouseleave', function () {
        var partName = $(this).attr('id');
        $('li[name="' + partName + '"]').removeClass('active');
        $(this).removeClass('active');
    });

    $('.common li').on('mouseenter', function () {
        var symptomName = $(this).attr('name');
        $(this).addClass('active');
        $('div#' + symptomName).addClass('active');
    }).on('mouseleave', function () {
        $(this).removeClass('active');
        $('div.body-part').removeClass('active');
    });

    //sign up form 
    // show/hide phone number field
    var radios = document.querySelectorAll('input[type=radio][name="signup"]'),
        phoneno = $('label[for="phone"]');

    function changeHandler(event) {
        if (this.value === 'become-ambassador') {
            $(phoneno).removeClass('hide');
        } else {
            $(phoneno).addClass('hide');
        }
    }
    Array.prototype.forEach.call(radios, function (radio) {
        radio.addEventListener('change', changeHandler);
    });

    // tooltips for glossary terms
    var myAbbrs = document.getElementsByClassName('abbr');
    for (var i = 0; i < myAbbrs.length; i++) {
        var abbr = myAbbrs[i];
        abbr.tooltip = new Tooltip(
            abbr,
            abbr,
            abbr.querySelector('.abbrcontent').innerHTML,
            Tooltip.positioningTypes.above,
            null);
    }

});


// WEBPACK FOOTER //
// ./Scripts/src/main.js